import { Injectable } from '@angular/core';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { adhocDto } from '../models/adhocDto';
import { approveAddhoc } from '../models/approveAdhoc';
import { JobRotationRequest } from '../models/requests/JobRotationVM';
import { JobRotationResp } from '../models/jobRotation';
import { RequestApprovalDto } from '../models/requestapproval-dto';
import { approveJobRotationVm } from '../models/approveJobRotation';

@Injectable({
  providedIn: 'root'
})
export class JobRotationService {

  private getHeaders(): HttpHeaders {
      return new HttpHeaders({
        'Authorization': `Bearer ${localStorage.getItem('AT')}`,
        'Content-Type': 'application/json'
      });
    }

  private request<T>(method: 'GET' | 'POST', url: string, body?: any): Observable<ApiResponseObject<T>> {
    return this.httpClient.request<ApiResponseObject<T>>(method, `${environment.apiUrl}/${url}`, {
      body,
      headers: this.getHeaders()
    });
  }

  constructor(private httpClient: HttpClient) { }

     createJobRotationRequest(request: JobRotationRequest): Observable<ApiResponseObject<any>> {
      
      return this.request('POST', 'JobRotation', request);
    }

    getRotationReqsForCurrentUser(email: string): Observable<ApiResponseObject<JobRotationResp[]>> {
       ; 
      var result = this.httpClient.get<ApiResponseObject<JobRotationResp[]>>(`${environment.apiUrl}/JobRotation/GetContractsForCurrentUser/${email}`);
      return result;
    } 

    getRequestApprovals(id:number): Observable<ApiResponseObject<RequestApprovalDto[]>> {
      ;
          return this.httpClient.get<ApiResponseObject<RequestApprovalDto[]>>(`${environment.apiUrl}/JobRotation/GetPendingApproval/${id}`);
        } 
  
    // getMyPendingJobRotations(): Observable<ApiResponseObject<JobRotationResp[]>> {
    //   return this.httpClient.get<ApiResponseObject<JobRotationResp[]>>(`${environment.apiUrl}/JobRotation/MyPendingContract` );
    // } 

    getMyPendingJobRotations(): Observable<ApiResponseObject<any>> {
      
      return this.request('GET', 'JobRotation/MyPendingContract');
    }
  
     approveJobRotation(approveJobRotationRequest: approveJobRotationVm): Observable<ApiResponseObject<boolean>> {
     
      return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/JobRotation/Approve`, approveJobRotationRequest);
    }

    rejectJobRotation(rejectJobRotationRequest: approveJobRotationVm): Observable<ApiResponseObject<boolean>> {
     
      return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/JobRotation/Reject`, rejectJobRotationRequest);
    }






}
